var React = require('react');

function AlertIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#1E1E1E","fillRule":"evenodd","d":"M27.451 27.491H7.55V14.088c0-5.543 4.463-10.052 9.951-10.052s9.951 4.509 9.951 10.052v13.403zM17.5 34.192c-1.83 0-3.317-1.503-3.317-3.35h6.634c0 1.847-1.487 3.35-3.317 3.35zm14.927-6.701h-1.659V14.088C30.768 6.698 24.816.686 17.5.686c-7.316 0-13.268 6.012-13.268 13.402v13.403H2.573c-.917 0-1.659.749-1.659 1.675 0 .927.742 1.676 1.659 1.676H10.866c0 3.695 2.975 6.7 6.634 6.7 3.659 0 6.634-3.005 6.634-6.7h8.294c.916 0 1.658-.75 1.658-1.676 0-.926-.742-1.675-1.659-1.675z","opacity":".8"}));
}

AlertIcon.defaultProps = {"width":"35","height":"38","viewBox":"0 0 35 38"};

module.exports = AlertIcon;

AlertIcon.default = AlertIcon;
